/**
 * Returns the Open Graph (OG) image object based on the provided hero object.
 * @param {Object} hero - The hero object containing media items.
 * @returns {Object} - The OG image object with URL, type, width, and height properties.
 */
export default (hero) => {
  const ogImage = {}

  if (hero && hero?.items?.length && hero?.items[0]) {
    const media = hero?.items[0]?.media

    // Set poster, if available, before testing for image
    if (media?.video && media?.video?.poster_image) {
      ogImage.url = media?.video?.poster_image.url
      ogImage.type = media?.video?.poster_image.mime_type
      ogImage.width = media?.video?.poster_image.width
      ogImage.height = media?.video?.poster_image.height
    } else if (media.image) {
      ogImage.url = media?.image?.url
      ogImage.type = media?.image?.mime_type
      ogImage.width = media?.image?.width
      ogImage.height = media?.image?.height
    }

    return ogImage
  }

  return {}
}
